import styled from 'styled-components';

export const Container = styled.div`
  border-top: 1px solid var(--color-grey6A);
  margin: 50px 0;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
`;

export const Label = styled.p`
  color: var(--color-grey6A);
  font-size: var(--font-size15);
  font-weight: var(--font-weight600);
  line-height: 1.2;
  letter-spacing: 0;
  text-align: left;
`;

export const Button = styled.button`
  display: flex;
  align-self: flex-end;
  outline: none;
  cursor: pointer;
  background: none;
  border: none;
  border-radius: 9px;
  transition: all 0.3s;
  @media (hover) {
    &:hover {
      background-color: var(--color-greyF3);
    }
  }
`;
